export default __webpack_public_path__ + "static/media/bitcoin-blue.caffeb6e.svg";